declare var process: any;

import 'core-js';
import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { AppWrapper } from './components';
import { store, history } from './redux';
import views from './views';
import Error from './views/Error';
import './scss/style.scss';

Sentry.init({
  release: `hirus-app@${process.env.VERSION}`,
  dsn: process.env.SENTRY_DSN,
});

// Register service worker
if ('serviceWorker' in navigator) {
  console.log('CLIENT: service worker registration in progress.');
  navigator.serviceWorker.register('service-worker.js').then(
    () => {
      console.log('CLIENT: service worker registration complete');
    },
    () => {
      console.log('CLIENT: service worker registration failure.');
    },
  );
} else {
  console.log('CLIENT: service worker is not supported.');
}

// Render application
render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppWrapper>
        <Switch>
          {views.map((view) => (
            <Route
              key={view.path}
              exact
              path={view.path}
              component={view.component}
            />
          ))}
          <Route component={Error} />
        </Switch>
      </AppWrapper>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app'),
);
